import "core-js/modules/es.array.push.js";
import { Tooltip } from '../../blocks/output-elements/tooltip';
import i18nHelper from '../../myAccount/helper/i18n-helper';
export default {
  name: 'AdditionalDetails',
  props: ['item', 'isMultiPo', 'shipToCountry', 'isCheckout'],
  components: {
    Tooltip
  },
  methods: {
    getLabel(key) {
      return window.Granite.I18n.get(key);
    },
    materialDescription: function (item) {
      return item.myPartDescription ? item.myPartDescription : item.materialDescription;
    },
    materialNumber: function (item) {
      if (item.myPartNumber) {
        return i18nHelper.getI18nMessage('part.no.Title') + ' ' + item.myPartNumber;
      } else {
        return i18nHelper.getI18nMessage('material.no.variable.Title', [item.materialNumber]);
      }
    },
    materialNumberInfoIText: function (item) {
      return i18nHelper.getI18nMessage('material.no.variable.Title', [item.materialNumber]);
    }
  },
  computed: {
    // creditCardPayment: function () {
    //     return this.item?.paymentTerms == '2025'
    // },
    isSurchargeOrDiscount: function () {
      return this.item.orderSurcharges.some(({
        conditionValue
      }) => conditionValue && parseFloat(conditionValue) !== 0.0);
    },
    surchargeDiscountLabels: function () {
      const pricingConditions = this.item.orderSurcharges;
      const surchargeDiscountLabels = [];
      if (pricingConditions) {
        pricingConditions.forEach(price => {
          let conditionDescription = price.conditionDescription || '';
          let conditionAmount = price.formatConditionAmount;
          let conditionAmountUnit = price.conditionAmountUnit;
          let conditionUOM = price.conditionUOM;
          let combinedLabel = '';
          if (price.conditionCalculationType === 'C') {
            if (price.conditionPricingUnit > 1) {
              combinedLabel = `${conditionDescription} (${conditionAmount} ${conditionAmountUnit} / ${price.conditionPricingUnit} ${conditionUOM})`;
            } else {
              combinedLabel = `${conditionDescription} (${conditionAmount} ${conditionAmountUnit} / ${conditionUOM})`;
            }
          }
          if (price.conditionCalculationType === 'A') {
            combinedLabel = `${conditionDescription} (${conditionAmount}%)`;
          }
          if (price.conditionClass !== 'D' || price.conditionAmountUnit === 'BRL' || this.shipToCountry === 'BR') {
            surchargeDiscountLabels.push(combinedLabel);
          }
        });
      }
      return surchargeDiscountLabels;
    },
    surchargeDiscountValues: function () {
      const pricingConditions = this.item.orderSurcharges;
      const surchargeDiscountValues = [];
      if (pricingConditions) {
        pricingConditions.forEach(price => {
          let value = price.formatConditionValue;
          let currency = price.conditionAmountUnit;
          let combinedValue = value + ' ' + currency;
          if (price.conditionClass !== 'D' || price.conditionAmountUnit === 'BRL' || this.shipToCountry === 'BR') {
            surchargeDiscountValues.push(combinedValue);
          }
        });
      }
      return surchargeDiscountValues;
    },
    displayDeliveryTolerance: function () {
      var overDeliveryToleranceFloat = this.item?.overDeliveryTolerance;
      var underDeliveryToleranceFloat = this.item?.underDeliveryTolerance;
      if (overDeliveryToleranceFloat && typeof overDeliveryToleranceFloat === 'string') {
        overDeliveryToleranceFloat = parseFloat(overDeliveryToleranceFloat);
      }
      if (underDeliveryToleranceFloat && typeof underDeliveryToleranceFloat === 'string') {
        underDeliveryToleranceFloat = parseFloat(underDeliveryToleranceFloat);
      }
      if (overDeliveryToleranceFloat && overDeliveryToleranceFloat != 0 && overDeliveryToleranceFloat != 25 || underDeliveryToleranceFloat && underDeliveryToleranceFloat != 0 && underDeliveryToleranceFloat != 25) {
        return true;
      } else {
        return false;
      }
    },
    deliveryTolerance: function () {
      if (this.displayDeliveryTolerance) {
        if (this.item.overDeliveryTolerance && this.item.underDeliveryTolerance) {
          if (this.item.overDeliveryTolerance !== this.item.underDeliveryTolerance) {
            return '+ ' + this.item.overDeliveryTolerance + ' / - ' + this.item.underDeliveryTolerance + '%';
          } else {
            return '+/- ' + this.item.overDeliveryTolerance + '%';
          }
        }
        if (this.item.overDeliveryTolerance) {
          return '+ ' + this.item.overDeliveryTolerance + '%';
        }
        if (this.item.underDeliveryTolerance) {
          return '- ' + this.item.underDeliveryTolerance + '%';
        }
      } else {
        return '';
      }
    }
  }
};